import { render, staticRenderFns } from "./ViewCheckoffAttachments.vue?vue&type=template&id=be384d10&scoped=true"
import script from "./ViewCheckoffAttachments.vue?vue&type=script&lang=js"
export * from "./ViewCheckoffAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be384d10",
  null
  
)

export default component.exports